import { DAY_MONTH_YEAR } from '@/libs/filterDate'
import { IDR } from '@/libs/currency'
import { defaultThClass, defaultThStyle } from '../../config'

const defaultClass = {
  tdClass: '!font-[400] text-[#333333]',
  class: `${defaultThClass} !text-[14px] !min-w-[180px] !text-[#333333] !align-middle`,
}

export const hashCardConst = {
  'Transaksi Biaya Fulfillment': 'tbf',
  'Transaksi Biaya Penarikan': 'tbp',
  'Transaksi Biaya Low Moving Stock': 'tblms',
}

export const hashCardTitle = {
  tbf: 'Transaksi Biaya Fulfillment',
  tbp: 'Transaksi Biaya Penarikan',
  tblms: 'Transaksi Biaya Low Moving Stock',
}

export const fieldsPenarikanBarang = [
  {
    key: 'name',
    label: 'Nama',
    thClass: defaultClass.class,
    tdClass: defaultClass.tdClass,
  },
  {
    key: 'email',
    label: 'Email',
    thClass: defaultClass.class,
    tdClass: defaultClass.tdClass,
  },
]

export const fieldsPenarikan = [
  {
    key: 'created_at',
    label: 'Tanggal Pengajuan',
    thClass: `${defaultClass.class} !min-w-[210px]`,
    tdClass: defaultClass.tdClass,
    formatter: value => DAY_MONTH_YEAR(value),
  },
  {
    key: 'partner_name',
    label: 'Partner',
    thClass: defaultClass.class,
    tdClass: defaultClass.tdClass,
  },
  {
    key: 'type',
    label: 'Aktivitas',
    thClass: defaultClass.class,
    tdClass: defaultClass.tdClass,
  },
  {
    key: 'warehouse_name',
    label: 'Mitra Gudang',
    thClass: defaultClass.class,
    tdClass: defaultClass.tdClass,
  },
  {
    key: 'total_product',
    label: 'Produk',
    thClass: `${defaultClass.class} !min-w-[80px]`,
    tdClass: defaultClass.tdClass,
  },
  {
    key: 'fulfillment_fee',
    label: 'Nominal Transaksi',
    thClass: `${defaultClass.class} !min-w-[220px]`,
    tdClass: defaultClass.tdClass,
    formatter: value => IDR(value),
  },
  {
    key: 'kompack_revenue',
    label: 'Revenue Kompack',
    thClass: `${defaultClass.class} !min-w-[220px]`,
    tdClass: defaultClass.tdClass,
    formatter: value => IDR(value),
  },
  {
    key: 'status',
    label: 'Status',
    thClass: `${defaultClass.class} !min-w-[120px]`,
    tdClass: defaultClass.tdClass,
  },
  {
    key: 'outbound_id',
    label: 'Rincian',
    thClass: `${defaultClass.class} !min-w-[140px]`,
    tdClass: defaultClass.tdClass,
  },
]

export const fieldsFulfillmentKomship = [
  {
    key: 'created_at',
    label: 'Waktu Pengajuan',
    thClass: `${defaultClass.class} !min-w-[210px]`,
    tdClass: defaultClass.tdClass,
  },
  {
    key: 'partner_name',
    label: 'Partner',
    thClass: `${defaultClass.class} !min-w-[280px]`,
    tdClass: defaultClass.tdClass,
  },
  {
    key: 'warehouse_name',
    label: 'Gudang',
    thClass: `${defaultClass.class} !min-w-[280px]`,
    tdClass: defaultClass.tdClass,
  },
  {
    key: 'total_order',
    label: 'Order',
    thClass: `${defaultClass.class} !min-w-[120px]`,
    tdClass: defaultClass.tdClass,
  },
  {
    key: 'total_product',
    label: 'Produk',
    thClass: `${defaultClass.class} !min-w-[120px]`,
    tdClass: defaultClass.tdClass,
  },
  {
    key: 'total_fulfillment_fee',
    label: 'Nominal Transaksi',
    thClass: defaultClass.class,
    tdClass: defaultClass.tdClass,
    formatter: value => IDR(value),
  },
  {
    key: 'total_print',
    label: 'Status Packing',
    thClass: defaultClass.class,
    tdClass: defaultClass.tdClass,
  },
  {
    key: 'request_id',
    label: 'Rincian',
    thClass: defaultClass.class,
    tdClass: defaultClass.tdClass,
  },
]

export const fieldsFulfillmentNonKomship = [
  {
    key: 'outbound_id',
    label: 'Outbond ID',
    thClass: `${defaultClass.class} !min-w-[200px]`,
    tdClass: defaultClass.tdClass,
  },
  {
    key: 'created_at',
    label: 'Tanggal Order',
    thClass: defaultClass.class,
    tdClass: defaultClass.tdClass,
  },
  {
    key: 'partner_name',
    label: 'Partner',
    thClass: `${defaultClass.class} !min-w-[250px]`,
    tdClass: defaultClass.tdClass,
  },
  {
    key: 'warehouse_name',
    label: 'Mitra Gudang',
    thClass: `${defaultClass.class} !min-w-[250px]`,
    tdClass: defaultClass.tdClass,
  },
  {
    key: 'total_products',
    label: 'Produk',
    thClass: `${defaultClass.class} !min-w-[80px]`,
    tdClass: defaultClass.tdClass,
  },
  {
    key: 'fulfillment_fee',
    label: 'Nominal Transaksi',
    thClass: defaultClass.class,
    tdClass: defaultClass.tdClass,
    formatter: value => IDR(value),
  },
  {
    key: 'status',
    label: 'Status',
    thClass: defaultClass.class,
    tdClass: defaultClass.tdClass,
  },
  {
    key: 'action',
    label: 'Aksi',
    thClass: defaultClass.class,
    tdClass: defaultClass.tdClass,
  },
]

export const fieldsLowMovingStockTable = [
  {
    key: 'no',
    label: 'No',
    thStyle: {
      ...defaultThStyle,
      fontSize: '12px',
    },
    thClass: `${defaultClass.class} !min-w-[50px]`,
    tdClass: defaultClass.tdClass,
  },
  {
    key: 'partner_name',
    label: 'Nama Partner',
    thClass: defaultClass.class,
    tdClass: `${defaultClass.tdClass} !min-w-[250px]`,
  },
  {
    key: 'brand_name',
    label: 'Nama Bisnis',
    thClass: defaultClass.class,
    tdClass: `${defaultClass.tdClass} !min-w-[250px]`,
  },
  {
    key: 'warehouse_name',
    label: 'Mitra Gudang',
    thClass: defaultClass.class,
    tdClass: `${defaultClass.tdClass} !min-w-[250px]`,
  },
  {
    key: 'bill_type',
    label: 'Jenis Tagihan',
    thClass: defaultClass.class,
    tdClass: `${defaultClass.tdClass} !min-w-[200px]`,
  },
  {
    key: 'period',
    label: 'Periode',
    thClass: defaultClass.class,
    tdClass: `${defaultClass.tdClass} !min-w-[80px]`,
  },
  {
    key: 'fulfillment_fee',
    label: 'Nominal Tagihan',
    thClass: defaultClass.class,
    tdClass: `${defaultClass.tdClass} !min-w-[250px]`,
    formatter: value => IDR(value),
  },
  {
    key: 'kompack_revenue',
    label: 'Revenue Kompack',
    thClass: `${defaultClass.class} !min-w-[220px]`,
    tdClass: defaultClass.tdClass,
    formatter: value => IDR(value),
  },
  {
    key: 'status',
    label: 'Status',
    thStyle: {
      ...defaultThStyle,
      fontSize: '12px',
      minWidth: '180px',
    },
    ...defaultClass,
  },
  {
    key: 'ref_id',
    label: 'Rincian',
    thStyle: {
      ...defaultThStyle,
      fontSize: '12px',
      minWidth: '213px',
    },
    thClass: defaultClass.class,
    tdClass: `${defaultClass.tdClass} !px-[12px]`,
  },
]

export const fieldsFulfillmentMarketplace = [
  {
    key: 'order_date',
    label: 'Tanggal Order',
    thClass: defaultClass.class,
    tdClass: defaultClass.tdClass,
  },
  {
    key: 'marketplace_order_id',
    label: 'No. Order',
    thClass: `${defaultClass.class} !min-w-[120px]`,
    tdClass: defaultClass.tdClass,
  },
  {
    key: 'partner_name',
    label: 'Partner',
    thClass: `${defaultClass.class} !min-w-[250px]`,
    tdClass: defaultClass.tdClass,
  },
  {
    key: 'warehouse_name',
    label: 'Mitra Gudang',
    thClass: `${defaultClass.class} !min-w-[250px]`,
    tdClass: defaultClass.tdClass,
  },
  {
    key: 'total_item',
    label: 'QTY Produk',
    thClass: defaultClass.class,
    tdClass: defaultClass.tdClass,
  },
  {
    key: 'fulfillment_fee',
    label: 'Nominal Transaksi',
    thClass: defaultClass.class,
    tdClass: defaultClass.tdClass,
    formatter: value => IDR(value),
  },
  {
    key: 'status',
    label: 'Status',
    thClass: defaultClass.class,
    tdClass: defaultClass.tdClass,
  },
  {
    key: 'id',
    label: 'Rincian',
    thClass: defaultClass.class,
    tdClass: defaultClass.tdClass,
  },
]

export const transactionTypeOptions = {
  komship: [
    {
      text: 'Semua',
      value: undefined,
    },
    {
      text: 'Diajukan',
      value: 'Diajukan',
    },
    {
      text: 'Dipacking',
      value: 'Dipacking',
    },
    {
      text: 'Dikirim',
      value: 'Dikirim',
    },
    {
      text: 'Diterima',
      value: 'Diterima',
    },
    {
      text: 'Retur',
      value: 'Retur',
    },
    {
      text: 'Batal',
      value: 'Batal',
    },
    {
      text: 'Hilang',
      value: 'Hilang',
    },
    {
      text: 'Rusak',
      value: 'Rusak',
    },
    {
      text: 'Fake',
      value: 'Fake',
    },
  ],
  nonkomship: [
    {
      text: 'Semua',
      value: undefined,
    },
    {
      text: 'Belum Dipacking',
      value: 'Belum Dipacking',
    },
    {
      text: 'Dipacking',
      value: 'Dipacking',
    },
    {
      text: 'Terkirim',
      value: 'Dikirim',
    },
    {
      text: 'Dibatalkan',
      value: 'Dibatalkan',
    },
  ],
  marketplace: [
    {
      text: 'Semua',
      value: undefined,
    },
    {
      text: 'Belum Dipacking',
      value: 'submitted',
    },
    {
      text: 'Dipacking',
      value: 'confirmed',
    },
    {
      text: 'Dikirim',
      value: 'shipped',
    },
    {
      text: 'Selesai',
      value: 'completed',
    },
    {
      text: 'Dibatalkan',
      value: 'cancelled',
    },
  ],
}

export const statusMapping = {
  Unknown: {
    label: 'Unknown',
    color: {
      main: '#000000',
      sub: '#E2E2E2',
    },
  },
  'Belum Dipacking': {
    label: 'Belum Dipacking',
    color: {
      main: '#3B82F6',
      sub: '#EFF6FF',
    },
  },
  Dipacking: {
    label: 'Dipacking',
    color: {
      main: '#F95E16',
      sub: '#FFE8D9',
    },
  },
  'Menunggu Pickup': {
    label: 'Menunggu Pickup',
    color: {
      main: '#FBBC05',
      sub: '#FEF2CD',
    },
  },
  Dikirim: {
    label: 'Terkirim',
    color: {
      main: '#34A770',
      sub: '#DCF3EB',
    },
  },
  Dibatalkan: {
    label: 'Dibatalkan',
    color: {
      main: '#DC2626',
      sub: '#FEF2F2',
    },
  },
}
